// ======================================================================
// File Name       : SelectedBoxList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Table, Button, Form } from 'react-bootstrap';

class SelectedBoxList extends Component {
  render() {
    const { csvDownload } = this.props;
    const { addedBoxList } = csvDownload;
    const boxList = Object.keys(addedBoxList).sort((a, b) => {
      if (addedBoxList[a].addNew && !addedBoxList[b].addNew) {
        return -1;
      } if (!addedBoxList[a].addNew && addedBoxList[b].addNew) {
        return 1;
      }
      if (addedBoxList[a].index < addedBoxList[b].index) {
        return -1;
      } if (addedBoxList[a].index > addedBoxList[b].index) {
        return 1;
      }
      return 0;
    });

    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-top-10 padding-left-right-clear">
          対象セクション
        </Col>
        <Col sm={10} className="text-right padding-left-right-clear margin-bottom-5">
          <Button onClick={this.props.handleRemoveAllBoxes}>セクション一括削除</Button>
        </Col>

        <Table id="scroll-table-box" striped hover variant="primary" className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-11">セクション名</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {boxList.map((boxSecernId, index) => {
              const data = addedBoxList[boxSecernId];
              return (
                <tr key={index} className={data.addNew ? 'background_new_record' : ''}>
                  <td>{data.boxName}</td>
                  <td className="text-center">
                    <i
                      role="button"
                      className="bi bi-trash"
                      onClick={this.props.handleRemoveBox.bind(this, boxSecernId)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Form.Group className="margin-top-20 text-center col-sm-12">
          <Button
            variant="primary"
            className="btn-96 margin-right-10"
            onClick={this.props.onCancel}
          >
            戻る
          </Button>
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.props.onOK}
          >
            OK
          </Button>
        </Form.Group>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { csvDownload } = state;
  return { csvDownload };
};
export default connect(mapStateToProps)(SelectedBoxList);

